<rt-bulk-selection-messages
  [selectedCount]="totalSelectedCount"
  [currentViewSelectedCount]="currentViewSelectedCount"
  [hasBottomMargin]="hasBottomMargin()"
  [hasTopMarginMedium]="hasTopMargin()"
  (clearSelection)="handleSelectionClear()"
/>
